import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "context/media/MediaContext";
import { useAppDispatch } from "redux/hooks";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { Button, Panel, PanelHeader, Spinner, Typography } from "components";
import { Col, Row } from "components/BaseComponents/Flex";
import { setServiceError } from "redux/slices/ServiceInlineError";
import { TokenInclude } from "helpers/GetToken";
import { PasswordSendAsync } from "services/password/password.service";

type PasswordSmsProp = {
  agentPhonenumber: string;
};
const PasswordSms: FC<PasswordSmsProp> = ({ agentPhonenumber }) => {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const token = TokenInclude();
  const [isLoading, setIsLoading] = useState(false);

  const [isAddSuccess, setIsAddSuccess] = useState<boolean>(false);

  const PasswordSend = async () => {
    setIsLoading(true);
    const retVal = await PasswordSendAsync(agentPhonenumber, token);
    if (retVal?.DialogBoxes?.length < 1) {
      setIsLoading(false);
      setIsAddSuccess(true);
    } else {
      const errMessage: any = retVal;
      setIsLoading(false);
      dispatch(setServiceError(errMessage));
      return;
    }
  };

  return (
    <Panel width='646px' marginTop='0'>
      <Spinner show={isLoading} />
      <PanelHeader
        title={t("change_passsword_enter_password")}
        backgroundColor={DIGIPOSTHEME.colors.secondaryGrayTertiary}
      />
      {!isAddSuccess && (
        <>
          <Row
            width='100%'
            backgroundColor={DIGIPOSTHEME.colors.white}
            justifyContent='center'
            noMargin
          >
            <Typography
              width=''
              margin='10px 0'
              size={isMobile ? "15px" : "17px"}
              color={DIGIPOSTHEME.colors.black}
            >
              {t("agent_password_change_approve").toString()}
            </Typography>
          </Row>
          <Row
            width='100%'
            backgroundColor={DIGIPOSTHEME.colors.white}
            justifyContent='center'
            noMargin
          >
            <Typography
              width=''
              margin='10px 10px'
              size={isMobile ? "13px" : "15px"}
              color={DIGIPOSTHEME.colors.secondaryGraySecondary}
            >
              {t("agent_password_change_sms_info").toString()}
            </Typography>
          </Row>
        </>
      )}
      <Row padding='20px 0' noMargin>
        <Row
          backgroundColor={DIGIPOSTHEME.colors.white}
          justifyContent='space-between'
          isResponsive
          noMargin
          width='100%'
        >
          {isAddSuccess ? (
            <>
              <Row
                backgroundColor={DIGIPOSTHEME.colors.white}
                isResponsive
                noMargin
                width='100%'
                justifyContent='center'
              >
                <Typography
                  width=''
                  margin='10px 10px'
                  size={isMobile ? "13px" : "15px"}
                  color={DIGIPOSTHEME.colors.black}
                >
                  {t("agent_password_success_message").toString()}
                </Typography>
              </Row>
              <Row
                backgroundColor={DIGIPOSTHEME.colors.white}
                isResponsive
                noMargin
                width='100%'
                justifyContent='center'
              >
                <Col margin='0 10px' maxWidth='200px'>
                  <Button
                    type='button'
                    width={isMobile ? "100%" : "200px"}
                    text={t("send_sms_ok").toString()}
                    onClick={() => navigate("/employee-panel")}
                    margin={isMobile ? "10px 0 0 0" : "20px 0"}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Col margin='0 10px'>
                <Button
                  type='button'
                  width={isMobile ? "100%" : "100px"}
                  text={`← ${t("back")}`}
                  onClick={() => navigate(-1)}
                  color='light'
                  margin={isMobile ? "10px 0 0 0" : "20px 0"}
                />
              </Col>
              <Col margin='0 10px' maxWidth='200px'>
                <Button
                  type='button'
                  width={isMobile ? "100%" : "200px"}
                  text={t("send_sms_password").toString()}
                  onClick={() => PasswordSend()}
                  margin={isMobile ? "10px 0 0 0" : "20px 0"}
                />
              </Col>
            </>
          )}
        </Row>
      </Row>
    </Panel>
  );
};

export default PasswordSms;
